<div *ngIf="supportsPDFs" #pdf class="pdf"></div>
<mg-ui-button
    *ngIf="proceedButtonText"
    (click)="handleButtonClick()"
    class="proceed-button"
    [simplifyMobileStyling]="true"
>
    {{ proceedButtonText }}
</mg-ui-button>
<mg-ui-button
    [linkTarget]="src"
    download="download.pdf"
    target="_blank"
    rel="noopener"
    class="pdfLink"
    [simplifyMobileStyling]="true"
>
    <span class="pdfLink__text--view">{{ viewButtonText }}</span>
    <span class="pdfLink__text--download">{{ downloadButtonText }}</span>
</mg-ui-button>
